import { FC } from 'react';

interface TemplateValidationProps {
  convertToHtml: {
    isPending: boolean;
  };
  files: File[];
}

const TemplateValidation: FC<TemplateValidationProps> = ({ convertToHtml, files }) => {
  return (
    <div className="w-full mt-4">
      <p className="text-lg font-medium text-primary-300 mb-2">Style Validation Results</p>
      {convertToHtml.isPending ? (
        <div className="mt-4">
          <p className="text-sm text-gray-500">Processing document...</p>
        </div>
      ) : files.length > 0 ? (
        <p className="text-sm text-neutral-600">Style validation is skipped for this upload.</p>
      ) : (
        <p className="text-sm text-neutral-600">Upload a document to continue.</p>
      )}
    </div>
  );
};

export default TemplateValidation;
